import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';
import { StarIcon } from 'lucide-react';

export function PointIcon(pointIconProps: ComponentProps<'span'>) {
  const { className, ...props } = pointIconProps;
  return (
    <span data-slot="point-icon" aria-hidden="true" className={cn('bg-purple-accent relative flex size-5.5 shrink-0 items-center justify-center rounded-full p-1 shadow-xs', className)} {...props}>
      <StarIcon className="stroke-purple fill-purple aspect-square h-full w-full shrink-0" />
    </span>
  );
}
